import React from 'react';
import styled from 'styled-components';

const Button = ({ button, selectedButton, selectedButtonUpdate }) => {

    const onClick = () => {
        selectedButtonUpdate(button)
    }

    const isActive = (selectedButton.name === button.name) ? 'active' : 'inactive';
    const isMobile = navigator.maxTouchPoints > 0 ? 'mview' : 'dview'

    return (
        <ButtonStyled className='Button' onClick={ onClick }>
            <div className={`d-grid gap-2`}>
                <button type='button' className={`btn btn-primary ${ isActive } ${ isMobile }`}>{ button.name }</button>
            </div>
        </ButtonStyled>
    );
}

export default Button;

const ButtonStyled = styled.div`
    .active {
        background-color: #3fa8f4;
        color: white;
        border: 2px solid #3fa8f4;
    }
    .mview {
        display: none;
    }
    button {
        text-transform: uppercase;
        border: 2px solid #3fa8f4;
        border-radius: 20px;
        padding: 5px 35px;
        background-color: white;
        color: #3fa8f4;
        font-size: 16px;
        font-weight: bold;
    }
`;